import React, { useState } from 'react';
import { Form, Modal } from 'semantic-ui-react';
import '../localization/config';
import { useTranslation } from 'react-i18next';
import { FlexRow } from '../layouts';

export interface IForgotPasswordModal {
  open: boolean;

  onSubmit(_url: string): void;
  onCancel(): void;
}

const ForgotPasswordModal = (props: IForgotPasswordModal) => {
  const { open, onSubmit, onCancel } = props;
  const [email, setEmail] = useState<string>('');

  const { t } = useTranslation();

  const handleChange = (e: any) => {
    setEmail(e.target.value);
  };

  return (
    <Modal open={open} as={Form} style={{ width: 600 }}>
      <>
        <Modal.Header>{t('LoginModal.forgotPassword')}</Modal.Header>
        <Modal.Content>
          <Form.Field>
            <input
              type="text"
              placeholder={t('home.email')}
              value={email}
              onChange={handleChange}
            />
          </Form.Field>
          <FlexRow fullWidth right>
            <Form.Button onClick={onCancel} color="grey">
              {t('general.cancel')}
            </Form.Button>
            <Form.Button
              onClick={() => {
                onSubmit(email as string)
              }}
              color="green"
              disabled={email.length < 1}
            >
              {t('general.save')}
            </Form.Button>
          </FlexRow>
        </Modal.Content>
      </>
    </Modal>
  );
};

export default ForgotPasswordModal;
